import setAxiosConfig from 'helper/axios';
import appConfig from 'helper/mapBackendConfig';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { SagaMiddleware } from 'redux-saga';
import rootSaga from 'sagas/rootSaga';
import rootReducer from 'store/rootReducer';
import { State } from 'types/Store';

// const ENV: string = process.env.NODE_ENV || 'production';
const sagaMiddleware: SagaMiddleware<any> = createSagaMiddleware();
const initialState: State = {};

// Disable Redux devtools in production
const composeEnhancers: Function = !!appConfig.env.devToolsEnabled
	? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
	: compose;

// Main redux store instance
const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(sagaMiddleware)));

// Setting defaults for axios client
setAxiosConfig(store as any);

// Run sagas with middleware
sagaMiddleware.run(rootSaga);

export { sagaMiddleware };
export default store;
